module.exports = __webpack_public_path__ + "assets/img/ic_dropdown_arrow_rounded-e283a2e5328070db8cbb046c343b1e99.svg";